import { defaultClient as ApolloClient } from "@/main";
import {
  CAT_VALUE_MERGE,
  CAT_VALUE_DELETE,
  CAT_MERGE,
  CAT_DELETE
} from "../../../graphql/categories/categoryM";
import {
  GET_CATEGORY,
  GET_CATEGORY_VALUE
} from "../../../graphql/categories/categoryQ";

export const actions = {
  allCategory: async ({ commit }) => {
    // commit("setLoading", true);
    return ApolloClient.query({
      query: GET_CATEGORY
    })
      .then(({ data }) => {
        commit("setCategory", data.allCategory);
        // commit("setLoading", false);
      })
      .catch(err => {
        // commit("setLoading", false);
        console.error(err);
      });
  },

  allCategoryValue: async ({ commit }) => {
    // commit("setLoading", true);
    return ApolloClient.query({
      query: GET_CATEGORY_VALUE
    })
      .then(({ data }) => {
        commit("setCategoryValue", data.allCategoryValue);
        // commit("setLoading", false);
      })
      .catch(err => {
        // commit("setLoading", false);
        console.error(err);
      });
  },
  categoryValueMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CAT_VALUE_MERGE,
      variables: payload,
      update: (cache, { data: { catValueMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_CATEGORY_VALUE
          });
          catValueMerge.node.category = {
            catName: payload.catName,
            __typename: "Category"
          };
          catValueMerge.node.valNameRus = "";
          catValueMerge.node.valDescRus = "";
          data.allCategoryValue.edges.push(catValueMerge);
          console.log(catValueMerge);
          cache.writeQuery({
            query: GET_CATEGORY_VALUE,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in categoryValueMerge update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allCategoryValue");
      })
      .catch(error => {
        throw new Error(
          `Error in categoryValueMerge action. Full info: ${error}`
        );
      });
  },
  categoryValueUpdate: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CAT_VALUE_MERGE,
      variables: payload,
      update: (cache, { data: { catValueMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_CATEGORY_VALUE
          });
          catValueMerge.node.category = {
            catName: payload.catName,
            __typename: "Category"
          };
          catValueMerge.node.valNameRus = "";
          catValueMerge.node.valDescRus = "";
          const currentValue = data.allCategoryValue.edges.filter(
            val => +val.node.valId === +payload.valId
          );
          const valIndx = data.allCategoryValue.edges.indexOf(currentValue[0]);
          if (valIndx !== -1) {
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(
              data.allCategoryValue.edges[valIndx].node
            )) {
              // eslint-disable-next-line no-unused-vars
              for (let [newKey, newValue] of Object.entries(payload)) {
                if (key === newKey) {
                  data.allCategoryValue.edges[valIndx].node[key] =
                    payload[newKey];
                }
              }
            }
          } else {
            console.error(
              "No index for update hook in categoryValueUpdate action"
            );
          }
          cache.writeQuery({
            query: GET_CATEGORY_VALUE,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in categoryValueMerge update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allCategoryValue");
      })
      .catch(error => {
        throw new Error(
          `Error in categoryValueMerge action. Full info: ${error}`
        );
      });
  },
  categoryValueDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CAT_VALUE_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_CATEGORY_VALUE
          });

          data.allCategoryValue.edges = data.allCategoryValue.edges.filter(
            el => +el.node.valId !== +payload.valId
          );

          cache.writeQuery({
            query: GET_CATEGORY_VALUE,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in categoryValueDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allCategoryValue");
      })
      .catch(err => {
        throw new Error(
          `Error in categoryValueDelete action. Full info: ${err}`
        );
      });
  },
  categoryMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CAT_MERGE,
      variables: payload,
      update: (cache, { data: { categoryMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_CATEGORY
          });
          data.allCategory.edges.push(categoryMerge);
          console.log(categoryMerge);
          cache.writeQuery({
            query: GET_CATEGORY,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in categoryMerge update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allCategory");
      })
      .catch(error => {
        throw new Error(`Error in categoryMerge action. Full info: ${error}`);
      });
  },
  categoryDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CAT_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_CATEGORY
          });

          data.allCategory.edges = data.allCategory.edges.filter(
            el => +el.node.catId !== +payload.catId
          );

          cache.writeQuery({
            query: GET_CATEGORY,
            data
          });
        } catch (error) {
          throw new Error(
            `Error in categoryDelete update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allCategory");
      })
      .catch(err => {
        throw new Error(`Error in categoryDelete action. Full info: ${err}`);
      });
  }
};
